export default __webpack_public_path__ + "45f564e83eb62962dff56e92df899c72.png";